var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    transform: "translate(-33 -144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    transform: "translate(33 144)",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_002-customer",
    "data-name": "002-customer",
    transform: "translate(39.374 151.601)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    className: "cls-2",
    cx: 3.209,
    cy: 3.209,
    r: 3.209,
    transform: "translate(6.449)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    className: "cls-2",
    cx: 2.093,
    cy: 1.953,
    rx: 2.093,
    ry: 1.953,
    transform: "translate(14.262 2.511)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    className: "cls-2",
    cx: 2.093,
    cy: 1.953,
    rx: 2.093,
    ry: 1.953,
    transform: "translate(.869 2.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-2",
    d: "M5.046 241.111a3.344 3.344 0 0 0-2.493-.579A2.548 2.548 0 0 0 0 243.07v4.106a1.1 1.1 0 0 0 1.106 1.1c2.633 0 2.316.048 2.316-.114 0-2.908-.345-5.041 1.624-7.051z",
    transform: "translate(0 -232.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    className: "cls-2",
    d: "M126.187 239.894a5.582 5.582 0 0 0-4.306 1.019c-2.063 1.652-1.666 3.877-1.666 6.6a1.319 1.319 0 0 0 1.317 1.317c7.937 0 8.253.256 8.724-.786.154-.352.112-.24.112-3.612a4.559 4.559 0 0 0-4.181-4.538z",
    transform: "translate(-115.665 -232.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "cls-2",
    d: "M380.3 240.533a3.342 3.342 0 0 0-2.493.579c1.954 1.995 1.624 3.983 1.624 7.054 0 .162-.263.114 2.276.114a1.144 1.144 0 0 0 1.145-1.141v-4.067a2.548 2.548 0 0 0-2.552-2.539z",
    transform: "translate(-363.604 -232.712)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.27df4d78.svg";
export { ForwardRef as ReactComponent };